export const eventColourPalette = [
  {name: 'White', colour: '#ffffff'},
  {name: 'Blue', colour: '#f0f5ff'},
  {name: 'Sky', colour: '#e3f2fd'},
  {name: 'Cyan', colour: '#e0f7fa'},
  {name: 'Teal', colour: '#effaf8'},
  {name: 'Aqua', colour: '#e0f2f1'},
  {name: 'Mint', colour: '#e8f5e9'},
  {name: 'Green', colour: '#f2f8ee'},
  {name: 'Lime', colour: '#f1f8e9'},
  {name: 'Yellow', colour: '#fffbea'},
  {name: 'Cream', colour: '#fff8e1'},
  {name: 'Peach', colour: '#fff3eb'},
  {name: 'Apricot', colour: '#fff0db'},
  {name: 'Coral', colour: '#ffebe6'},
  {name: 'Pink', colour: '#fff1f5'},
  {name: 'Rose', colour: '#fce4ec'},
  {name: 'Lavender', colour: '#f6f1ff'},
  {name: 'Lilac', colour: '#ede7f6'},
  {name: 'Mauve', colour: '#f3e5f5'},
  {name: 'Sand', colour: '#f5eee6'},
  {name: 'Grey', colour: '#f4f5f6'}
];

export function getEventTypeColour(site, eventType) {
  return site?.eventTypeColours?.find(item => item.eventType === eventType)?.colour || '#ffffff';
}
